<template>
    <div class="viewBox">
        <i class="el-icon-loading" v-if="isLoading"></i>
        <el-result icon="success" v-if="resultType==1"></el-result>
        <el-result icon="warning" v-if="resultType==2"></el-result>
        <div class="text-current">
            {{textCurrent}}
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isLoading: true,
            textCurrent: "关联跨境搜账号中...",
            resultType: 0,
        };
    },
    methods: {
        onRelevance(){
            let kjsUkey = this.$route.query.ukey;
            let crmUkey = localStorage.userInfo ? JSON.parse(localStorage.userInfo).uKey : "";
            if(!kjsUkey){
                this.isLoading = false;
                this.textCurrent = "关联失败";
                this.resultType = 2;
                return false;
            }
            this.$axios.get(`${this.$personnelUrl}/Staff/BindKjsAccount?crmUkey=${crmUkey}&kjsUkey=${kjsUkey}`).then((res) => {
                const { isSuccess } = res;
                this.isLoading = false;
                if (isSuccess) {
                    this.textCurrent = "关联跨境搜账号成功";
                    this.resultType = 1;
                }
            });
        }
    },
    mounted() {
        this.onRelevance();
    },
};
</script>

<style lang='scss' scoped>
.viewBox{
    text-align: center;
    padding-top: 200px;
    color: #3a3a3a;
    .el-icon-loading{
        font-size: 150px;
    }
    .text-current{
        font-size: 28px;
    }
}
</style>